import type * as React from 'react';
import styled from 'styled-components';

import type { VitaSkillFragment } from '@xing-com/crate-lebenslauf-graphql';

const FieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Value = styled.p`
  font-size: 10px;
  line-height: 13px;
  margin: 0;
`;

export const TemplateSkillItem: React.FC<VitaSkillFragment> = ({ skill }) => {
  return (
    <FieldContainer>{skill ? <Value>{skill}</Value> : null}</FieldContainer>
  );
};
